// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-roles__roles {\n  width: 100%;\n}\n.product-roles__roles tr td {\n  height: 35px !important;\n}\n.product-roles__roles tr td:last-child {\n  width: 50px;\n}\n.product-roles__roles .v-data-table__wrapper {\n  padding: 16px 0;\n  min-height: 260px;\n  background-color: var(--gray-600) !important;\n}\n.product-roles__item-switch .v-input__control {\n  height: 24px;\n}", ""]);
// Exports
module.exports = exports;
